import {useTheme} from '@mui/material/styles';

export const ContainerClasses = () => {
  const theme = useTheme();


  const containerRed = {
    backgroundColor: "red"
  }

  const containerBlue = {
    backgroundColor: "blue"
  }

  const containerLogo = {
  }

  const containerRowA =  {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center" //vertical alignment
  }

  const containerRowB =  {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center" //vertical alignment
  }

  const containerRowC =  {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center" //vertical alignment
  }

  const containerRowD =  {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center" //vertical alignment
  }

  const containerCol =  {
    display: "flex",
    flexDirection: "column",
    //  backgroundColor: "blue"
  }

  const containerColB =  {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }

  const containerCard = {
    marginTop: "4px",
    marginBottom: "4px",
    marginLeft: "4px",
    marginRight: "4px",
    borderRadius: 2
  }

  const containerErr = {
    marginTop: "4px",
    marginBottom: "4px",
    marginLeft: "4px",
    marginRight: "4px",
    color: "red",
    fontWeight: "bold",
    minHeight: 200,
    aligItems: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    borderRadius: 2
  }

  return {
    containerRed: containerRed,
    containerBlue: containerBlue,
    containerLogo: containerLogo,
    containerRowA: containerRowA,
    containerRowB: containerRowB,
    containerRowC: containerRowC,
    containerRowD: containerRowD,
    containerCol: containerCol,
    containerColB: containerColB,
    containerCard: containerCard,
    containerErr: containerErr
  }

}
